// Logger utility que funciona en desarrollo y producción (Vercel)
const logger = {
  log: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.log('[LOG]', ...args);
  },
  
  error: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.error('[ERROR]', ...args);
  },
  
  warn: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.warn('[WARN]', ...args);
  },
  
  info: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.info('[INFO]', ...args);
  },
  
  debug: (...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug('[DEBUG]', ...args);
    }
  },
  
  websocket: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.log('[WEBSOCKET]', ...args);
  },
  
  match: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.log('[MATCH]', ...args);
  },
  
  api: (...args: any[]) => {
    // eslint-disable-next-line no-console
    console.log('[API]', ...args);
  },
};

export { logger }; 